// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".statements-grid[data-v-4da340c0]{padding:0 2rem 1.5rem 2rem}@media(max-width: 991.98px){.statements-grid[data-v-4da340c0]{padding:0}}[data-v-4da340c0] .statement-status-column .ag-header-cell-label{padding-left:12px}", ""]);
// Exports
module.exports = exports;
